export const defaultBoardHeaderElements = [
  { label: "Fecha", value: "fecha", align: "inherit" },
  { label: "Soja", value: "precioSoja", align: "inherit" },
  { label: "Maíz", value: "precioMaiz", align: "inherit" },
  { label: "Trigo", value: "precioTrigo", align: "inherit" },
];

export const dollarHeaderElements = [
  { label: "Fecha", value: "fecha", align: "inherit" },
  { label: "Compra", value: "compra", align: "inherit" },
  { label: "Venta", value: "venta", align: "inherit" },
];

export const boardHeaderElements = [
  { label: "Fecha", value: "fecha", align: "inherit" },
  { label: "Soja", value: "precioSoja", align: "inherit" },
  { label: "Maíz", value: "precioMaiz", align: "inherit" },
  { label: "Trigo", value: "precioTrigo", align: "inherit" },
  { label: "Girasol", value: "precioGirasol", align: "inherit" },
  { label: "Sorgo", value: "precioSorgo", align: "inherit" },
];
